import React, { useEffect, useRef } from "react";

/**
 * Waveform Component
 * Displays an animated waveform visualization for audio input
 * @param {number[]} audioLevels - Array of audio level values (0-255)
 * @param {boolean} isRecording - Whether audio is currently being recorded
 * @param {object} style - Optional custom styles
 */
const Waveform = ({ audioLevels = [], isRecording = false, style = {} }) => {
	const containerRef = useRef(null);

	// Default styling
	const defaultStyle = {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: "4px",
		height: "64px",
		padding: "0 16px",
		...style,
	};

	// If no audio levels, show empty bars
	const levels = audioLevels.length > 0 ? audioLevels : Array(20).fill(0);

	return (
		<div ref={containerRef} style={defaultStyle} className="w-full">
			{levels.map((level, index) => {
				// Normalize level to height (0-255 -> 4-60px)
				const height = Math.max(4, (level / 255) * 60);
				return (
					<div
						key={index}
						className="rounded-full bg-white transition-all duration-75"
						style={{
							width: "3px",
							height: `${height}px`,
							minHeight: "4px",
							opacity: isRecording ? 1 : 0.5,
						}}
					/>
				);
			})}
		</div>
	);
};

export default Waveform;
